import { Component, OnDestroy, OnInit } from '@angular/core';
import { TourService } from '../../services/tour.service';
import { EventService } from '../../services/event.service';
import { Subscription } from 'rxjs';
import { ItemCategory, ItemCategoryCode } from '../../models/item-category';

@Component({
  selector: 'app-tour-items-bar',
  templateUrl: './tour-items-bar.component.html',
  styleUrls: ['./tour-items-bar.component.scss']
})
export class TourItemsBarComponent implements OnInit, OnDestroy {

  itemCount: {
    baggage: number,
    ski: number,
    bike: number,
    ebike: number,
    specialbike: number,
    cm: number
  } | undefined;

  iconName: {
    baggage: string,
    ski: string,
    bike: string,
    ebike: string,
    specialbike: string,
    cm: string
  }

  private tourChangedSubscription: Subscription;

  constructor(
    private tourService: TourService,
    private eventsService: EventService
  ) {
    this.iconName = {
      baggage: ItemCategory.getIconName(ItemCategoryCode.BAGGAGE),
      ski: ItemCategory.getIconName(ItemCategoryCode.SKI),
      bike: ItemCategory.getIconName(ItemCategoryCode.BIKE),
      ebike: ItemCategory.getIconName(ItemCategoryCode.EBIKE),
      specialbike: ItemCategory.getIconName(ItemCategoryCode.SPECIALBIKE),
      cm: ItemCategory.getIconName(ItemCategoryCode.CM)
    };
  }

  ngOnInit(): void {
    this.tourChangedSubscription = this.eventsService.tourChanged.subscribe(() => {
      this.updateTourItems();
    });
    this.updateTourItems();
  }

  ngOnDestroy(): void {
    if (this.tourChangedSubscription) {
      this.tourChangedSubscription.unsubscribe();
    }
  }

  private updateTourItems(): void {
    if (this.tourService.isStarted) {
      this.itemCount = {
        baggage: this.getItemCount(ItemCategoryCode.BAGGAGE) + this.getItemCount(ItemCategoryCode.GOLF),
        ski: this.getItemCount(ItemCategoryCode.SKI),
        bike: this.getItemCount(ItemCategoryCode.BIKE),
        ebike: this.getItemCount(ItemCategoryCode.EBIKE),
        specialbike: this.getItemCount(ItemCategoryCode.SPECIALBIKE),
        cm: this.getItemCount(ItemCategoryCode.CM)
      };
    } else {
      this.itemCount = undefined;
    }
  }

  private getItemCount(code: string): number {
    const tourItemCategory = this.tourService.tourItems.find(it => it.code === code);
    return tourItemCategory === undefined ? 0 : tourItemCategory.itemCount;
  }
}
